import React from "react";
import { Card, CardHeader, CardContent, Grid } from "@mui/material";
import {
  ToolImageStats,
  ToolImageUploadDataGrid,
} from "../components/toolSimulations";

const ToolSimulations = () => {
  return (
    <div className="fragmentContainer">
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <ToolImageStats />
        <Grid size={{ xs: 2, sm: 12, md: 12, lg: 12 }} >
          <Card variant="outlined" sx={{ padding: 0 }}>
            <CardHeader title="Available Truncation Tools"></CardHeader>
            <CardContent>
              <ToolImageUploadDataGrid />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default ToolSimulations;
